import { Capacitor } from "@capacitor/core";
import { originLooksLikeNativeWebView } from "./redirect";

function isAndroidWebViewUserAgent(): boolean {
  return typeof navigator !== "undefined" && /; wv\)/.test(navigator.userAgent);
}

/** Capacitor.isNativePlatform() can be false until the bridge is ready. Origin/UA are fallbacks. */
export function isNativeShell(): boolean {
  const platform = Capacitor.getPlatform();
  if (platform === "android" || platform === "ios") {
    return true;
  }
  if (Capacitor.isNativePlatform()) {
    return true;
  }
  if (isAndroidWebViewUserAgent()) {
    return true;
  }
  if (typeof window === "undefined") {
    return false;
  }
  return originLooksLikeNativeWebView(window.location.origin);
}
